module.exports = __webpack_public_path__ + "img/ep-B.04a82120.jpg";